import { Component, OnInit, AfterViewInit, Input, Output, ViewChild, EventEmitter, ElementRef } from '@angular/core';

import { DomHandler } from 'primeng/dom';

@Component({
    selector: 'agpr-popup-dialog',
    templateUrl: './popup-dialog.component.html',
    styleUrls: ['./popup-dialog.component.scss'],
    standalone: false
})
export class PopupDialogComponent implements OnInit, AfterViewInit {

    @Input() id: string;
    @Input() positionX: number = 100;
    @Input() positionY: number = 0;

    @Input() target?: HTMLElement;
    @Input() offset: number = 8;
    @Input() position: 'bottom' | 'top' | 'left' | 'right' = 'bottom';

    @Input() enableClickOutside: boolean = false;

    @Output() close: EventEmitter<void> = new EventEmitter<void>();

    @ViewChild('popoverElement', { static: false }) popoverElement?: ElementRef;

    public zIndex: number;

    constructor() {
        // Using the z-index the way PrimeNG uses it to make sure there are no conflicts
        this.zIndex = ++DomHandler.zindex;
    }

    ngOnInit() {
        if (this.target) {
            this.calculatePosition();
        }
    }

    ngAfterViewInit() {
        if (this.target) {
            requestAnimationFrame(() => this.calculatePosition());
        }
    }

    outsideClicked() {
        if (this.enableClickOutside) {
            this.close.emit();
        }
    }

    private calculatePosition() {
        if (!this.target) {
            return;
        }

        const rect = this.target.getBoundingClientRect();
        const scrollX = window.scrollX || window.pageXOffset;
        const scrollY = window.scrollY || window.pageYOffset;

        const popoverRect = this.popoverElement?.nativeElement?.getBoundingClientRect();
        const popoverHeight = popoverRect?.height || 0;
        const popoverWidth = popoverRect?.width || 0;


        switch (this.position) {
            case 'bottom':
                this.positionX = rect.left + scrollX;
                this.positionY = rect.bottom + scrollY + this.offset;
                break;

            case 'top':
                this.positionX = rect.left + scrollX;
                this.positionY = rect.top + scrollY - this.offset - popoverHeight;
                break;

            case 'left':
                this.positionX = rect.left + scrollX - this.offset - popoverWidth;
                this.positionY = rect.top + scrollY;
                break;

            case 'right':
                this.positionX = rect.right + scrollX + this.offset;
                this.positionY = rect.top + scrollY;
                break;
        }

        // Clamp to viewport boundaries so the dialog is never clipped
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;
        const margin = 8;

        // Prevent overflow on the right
        if (this.positionX + popoverWidth > scrollX + viewportWidth - margin) {
            this.positionX = scrollX + viewportWidth - popoverWidth - margin;
        }
        // Prevent overflow on the left
        if (this.positionX < scrollX + margin) {
            this.positionX = scrollX + margin;
        }
        // Prevent overflow on the bottom
        if (this.positionY + popoverHeight > scrollY + viewportHeight - margin) {
            this.positionY = scrollY + viewportHeight - popoverHeight - margin;
        }
        // Prevent overflow on the top
        if (this.positionY < scrollY + margin) {
            this.positionY = scrollY + margin;
        }
    }
}
